export enum MediaFileCategoryEnum {
  BACKGROUND_AUDIO = 'background',
  GAME_END_AUDIO = 'gameEnd',
  GAME_OBJECT_AUDIO = 'gameObjectAudio'
}
